 <div>
  <div
    class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl  xl:col-span-2">
    <div class="p-6">
      <div
        class="mr-4 truncate text-lg font-medium leading-6 tracking-tight">
        {{'Upcoming' | transloco}} {{'Vehicles' | transloco}}
      </div>
    </div>
    <div class="mx-6 overflow-x-auto">
      <table
        class="w-full bg-transparent"
        mat-table
        [dataSource]="dataSource()"
        [trackBy]="trackByFn"
        #upcomingVehiclesTable>

        <ng-container matColumnDef="Intern number and model">
          <th
            mat-header-cell
            *matHeaderCellDef>
            {{'InternNumberAndCarModel' | transloco}}
          </th>
          <td mat-cell *matCellDef="let car">
            <span
              class="text-secondary whitespace-nowrap pr-6 text-sm font-medium">
              {{ car.internNumber }}
            </span>
            <br />
            <span class="whitespace-nowrap pr-6">
              {{ car.fullName }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Estimated arrival">
          <th
            mat-header-cell
            *matHeaderCellDef>
            ETA
          </th>
          <td mat-cell *matCellDef="let car">
            <span class="whitespace-nowrap pr-6">
              {{ car.estimatedArrival | date: 'mediumDate' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Vehicle link">
          <th
            mat-header-cell
            *matHeaderCellDef>
            {{'Vehicle' | transloco}} link
          </th>
          <td mat-cell *matCellDef="let vehicle">
            <button
              mat-icon-button
              color="accent"
              class="self-end"
              (click)="openDetails(vehicle.vehicleId)">
              <mat-icon
                [svgIcon]="'heroicons_outline:link'"></mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"
          class="bg-gray-100 dark:bg-gray-700"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
      <app-pagination
        [pagination]="purchaseAdminService.upcomingVehiclesParams().pagination"
        (paginationChanged)="getVehicles()"></app-pagination>
    </div>
  </div>
</div>


